import React from 'react';
import { Modal, Button } from '@themesberg/react-bootstrap';
import { returnUserReadableDateTime } from '../../../utils/datetime';
import { formatTripsDuration } from '../loadersUtils';

const LoaderViewModal = (props) => {
  const { show, handleClose, loader } = props;

  return (
    <Modal centered show={show} onHide={handleClose} size="xl">
      <Modal.Header className="d-flex w-100 justify-content-between mb-2">
        <h4>Loader Details</h4>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div
          className="d-flex gap-2 width-100 p-2 justify-content-between mb-2"
          style={{ backgroundColor: '#F0F0F0' }}
        >
          <div>
            <p>Loader Code</p>
            <p>{loader?.currentLoader?.loader?.loaderCode}</p>
          </div>
          <div>
            <p>Loader Name</p>
            <p>{loader?.currentLoader?.loader?.name}</p>
          </div>
          <div>
            <p>Agency</p>
            <p>{loader?.currentLoader?.loader?.agency}</p>
          </div>
          <div>
            <p>Mobile No</p>
            <p>{loader?.currentLoader?.loader?.mobileNo}</p>
          </div>
          <div>
            <p>Warehouse</p>
            <p>{loader?.currentLoader?.warehouse}</p>
          </div>
          <div>
            <p>Entry Time</p>
            <p>
              {returnUserReadableDateTime(loader?.currentLoader?.entryTime)}
            </p>
          </div>
          <div>
            <p>Exit Time</p>
            <p>
              {returnUserReadableDateTime(loader?.currentLoader?.exitTime) ||
                'Still Working'}
            </p>
          </div>
        </div>
        <div>
          <h4>Performance</h4>
          <div className="d-flex justify-content-between w-100">
            <p>Trips Completed</p>
            <p>{loader?.trips?.length}</p>
          </div>
          <div className="d-flex justify-content-between w-100">
            <p>Time Spent</p>
            <p>
              {formatTripsDuration(
                loader?.trips?.reduce((acc, trip) => {
                  if (trip?.dispatchedAt) {
                    const dispatched = new Date(trip.dispatchedAt);
                    const closed = trip?.closedAt
                      ? new Date(trip.closedAt)
                      : new Date();
                    const diffSeconds = Math.floor(
                      (closed - dispatched) / 1000
                    );
                    return acc + diffSeconds;
                  }
                  return acc;
                }, 0)
              )}
            </p>
          </div>
          <div className="d-flex justify-content-between w-100">
            <p>Trip Number(s)</p>
            <div>
              {loader?.trips?.map((item) => (
                <p key={item?.tripNumber}>{item?.tripNumber || 'N/A'}</p>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-between w-100">
            <p>Assigned Vehicle(s)</p>
            <div>
              {loader?.trips?.map((item) => (
                <p key={item?.vehicleNumber}>{item?.vehicleNumber || 'N/A'}</p>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LoaderViewModal;
